<div class="date-range-filter date-range-filter--dense">
  <mat-form-field
    appearance="outline"
    class="date-range-filter__field date-range-filter__field--preset date-range-filter__field--no-subscript"
  >
    <mat-label>Range</mat-label>
    <mat-select
      [value]="selectedPreset"
      [disabled]="disabled"
      (selectionChange)="onPresetChange($event.value)"
      data-testid="shared-date-range-preset"
    >
      <mat-option *ngFor="let option of presetOptions" [value]="option.value">
        {{ option.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <span
    class="date-range-filter__navigation"
    data-testid="shared-date-range-before"
  >
    <ng-content select="[dateRangeBefore]"></ng-content>
  </span>

  <mat-form-field
    appearance="outline"
    class="date-range-filter__field date-range-filter__field--range date-range-filter__field--no-subscript"
  >
    <mat-label>{{ rangeLabel }}</mat-label>
    <mat-date-range-input [rangePicker]="rangePicker">
      <input
        matStartDate
        placeholder="Start"
        [ngModel]="draftFromDate"
        [ngModelOptions]="{ standalone: true }"
        [disabled]="disabled"
        (dateChange)="onStartDateChange($event.value)"
        data-testid="shared-date-range-start"
        readonly
      />
      <input
        matEndDate
        placeholder="End"
        [ngModel]="draftToDate"
        [ngModelOptions]="{ standalone: true }"
        [disabled]="disabled"
        (dateChange)="onEndDateChange($event.value)"
        data-testid="shared-date-range-end"
        readonly
      />
    </mat-date-range-input>
    <mat-datepicker-toggle
      matSuffix
      [for]="rangePicker"
    ></mat-datepicker-toggle>
    <mat-date-range-picker
      #rangePicker
      (closed)="onPickerClosed()"
    ></mat-date-range-picker>
  </mat-form-field>

  <span
    class="date-range-filter__navigation"
    data-testid="shared-date-range-after"
  >
    <ng-content select="[dateRangeAfter]"></ng-content>
  </span>
</div>
